export function addCurrent(macro) {
  return {
      type: 'ADD_CURRENT',
      macro,
  }
}